<template>
    <div class="finish list-box">

        <div v-if="pageState === 'list'" class="tree">
            <Tree @changeSwitch="changeSwitch" :switchVal="isDown" @nodeClick="nodeClick"></Tree>
        </div>
        <div v-if="pageState === 'list'" class="right-box">
            <TableSearch :search-config="searchConfig" :search-params="searchParams" @resetCallBack="reset()" @search="search"></TableSearch>
            <Table :tabelButtons="tabelButtons" :table-config="tableConfig" :pagination="pagination" :template-data="tableData"></Table>
        </div>

        <alarm-detail-im v-if="pageState === 'detail'" :alarm-id="alarmId" @back="backList"></alarm-detail-im>
    </div>
</template>

<script>
    import {listAPI} from '@/api-path/command-center.js'
    import Tree from '@/components/Tree/nodeTree';
    import AlarmDetailIm from '../alarm-detail-im/alarm-detail-im'
    export default {
        name: "finish",
        components: {
            Tree,
            AlarmDetailIm
        },
        data() {
            return {
                pageState: 'list',
                alarmId: '',
                isDown: false, // 是否查询下级
                searchConfig: {
                    items: [
                        {
                            placeholder: '输入姓名搜索',
                            key: 'search',
                        }, {
                            placeholder: '开始时间:结束时间',
                            valueType: 'datetimerange',
                            key: 'date'
                        }
                    ]
                },
                searchParams: {
                    areaId: '', // 区域ID
                    status: '3', // 事件状态
                    userId: sessionStorage.getItem('userId'), // 用户Id
                    search: '',
                    date: [],
                    page: 1,
                    size: 15,
                },
				tabelButtons:[],
                tableConfig: {
                    rows: [
                        {
                            label: '报警时间',
                            width: '130px',
                            prop: 'happenDate',
                        }, {
                            label: '报警人',
                            prop: 'userName',
                        }, {
                            label: '区域',
                            prop: 'areaName',
                        }, {
                            label: '报警方式',
                            prop: 'alarmType',
                        }, {
                            label: '接警来源',
                            width: '80px',
                            prop: 'sourceName',
                        },  {
                            label: '内容',
                            prop: 'content',
							width:'150px',
							type:"popover",
                        },  {
                            label: '地点',
                            prop: 'address',
							width:'200px',
							type:"popover",
                        },  {
                            label: '处理人',
                            prop: 'dealName',
                        },{
                            label: '接警中心',
                            prop: 'centerName',
                        },{
                            label: '状态',
                            prop: 'statusName',
                        },{
                            label:'用户评价',
                            width:'200px',
                            type:'rate',
                            prop:'score',
                            propContent:'evaluate',
                        }
                    ],
                    rowButtons: {
                        items: [
                            {
                                label: '查看',
                                fn: (data) => {
                                    this.alarmId = data.id
                                    this.pageState = 'detail'
                                }
                            }
                        ]
                    },
                },
                tableData: [],
                pagination: {
                    show: true,
                    page: 1,
                    size: 15,
                    total: 0,
                    sizeChange: (size) => {
                        this.pagination.size = size
                        this.searchParams.size = size
                        this.search()
                    },
                    pageChange: (page) => {
                        this.pagination.page = page
                        this.searchParams.page = page
                        this.search()
                    },
                },
            }
        },
		computed:{
			newAlarm(){
				return this.$store.state.hasNewAlarm//新的报警
			}
		},
		watch:{
			newAlarm(newVal,oldVal){
				if(newVal){
					this.search();
				}
			}
		},
        methods: {
            search() {
                const {date, ...params} = {...this.searchParams}
                params.startTime = date[0]
                params.endTime = date[1]
                params.isDown = this.isDown
                this.$http.get(listAPI.list, {params}).then(res => {
                    res.result.pageList.map(item => {
                        item.alarmSource = this.matchFn.matchCodeName('ALARM_SOURCE', item.alarmSource)
                        item.alarmType = this.matchFn.matchCodeName('ALARM_TYPE', item.alarmType)
                    })
                    this.tableData = res.result.pageList
                    this.pagination.total = res.result.total
					this.$store.commit('setHasNewAlarm',false)
                })
            },
            backList() {
              this.pageState = 'list'
            },
            changeSwitch(node) {
                this.isDown = node
                this.search()
            },
            nodeClick(node) {
                this.searchParams.areaId = node.id;
				this.searchParams.page=this.pagination.page=1;
				this.areaId=node.id;
                this.search();
            },
            reset() {
				this.searchParams.page=this.pagination.page=1;
				this.searchParams.size=this.pagination.size=15;
				this.searchParams.areaId=this.areaId;
				this.searchParams.userId=sessionStorage.getItem('userId');
				this.searchParams.status='3';
				this.searchParams.search='';
				this.searchParams.date=[];
				this.search();
            }
        }
    }
</script>

<style scoped>

</style>
